/*
 * Copyright (C) 2024 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

import {Typography} from '@mui/material';
import React from 'react';

export interface BeamInputLabelProps {
  label: string;
  required?: boolean;
  optional?: boolean;
  htmlFor: string;
}

const inputLabelStyle = {
  fontFamily: 'Source Sans Pro',
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '20px',
  color: '#9FAFBC',
};

export const BeamInputLabel = ({ label, required = false, optional = false, htmlFor }: BeamInputLabelProps) => {
  const decorators: JSX.Element[] = [];
  if (required) {
    decorators.push(
      <span key="required-label" style={{ ...inputLabelStyle, color: '#FA7272' }}>
        *
      </span>,
    );
  }
  if (optional) {
    decorators.push(
      <span key="optional-label" style={{ ...inputLabelStyle, fontWeight: 400 }}>
        {' '}
        (optional)
      </span>,
    );
  }

  return (
    <label htmlFor={htmlFor}>
      <Typography sx={inputLabelStyle}>
        {label}
        {decorators.map(decorator => decorator)}
      </Typography>
    </label>
  );
};
